import { Text } from '@chakra-ui/layout'

export function HeadingPages({ name, bgColor, ...rest }) {
  return (
    <Text
      paddingBlock="14px"
      bg={bgColor ? bgColor : '#378BBF'}
      textAlign="center"
      fontSize="16px"
      color="white"
      fontWeight="bold"
      {...rest}
    >
      {name}
    </Text>
  )
}
